module.exports = __webpack_public_path__ + "img/sample-room-2.fb680f40.png";